import { Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';
import { setInitialStoreState } from '../../../../../common/utils';
import { ShipmentListFacade } from './shipment-list.facade';
import { ListViewMode } from '../../constants';
import { AuthFacade, AuthUserData } from '../../../auth';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { map } from 'rxjs/operators';
import { ShipmentListSearchCriteria } from '../models/shipment.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentListGuard  {
  private storedMaterialViewValue: boolean | null = null;
  private storedViewModeValue: ListViewMode | null = null;

  constructor(
    private shipmentListFacade: ShipmentListFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    private authFacade: AuthFacade,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authFacade.userData$.pipe(
      switchMap((userData: AuthUserData) => {
        return this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.Shipment).pipe(
          map((searchCriteria: ShipmentListSearchCriteria) => {
            let { materialView, viewMode } = searchCriteria;

            if (this.storedMaterialViewValue === null || this.storedMaterialViewValue !== userData.isMaterialView) {
              materialView = userData.isMaterialView ?? false;
            }

            if (this.storedViewModeValue === null || this.storedViewModeValue !== userData.loadTOMode) {
              viewMode = userData.loadTOMode ?? ListViewMode.TransportOrder;
            }

            this.storedMaterialViewValue = userData.isMaterialView;
            this.storedViewModeValue = userData.loadTOMode;

            this.listSearchCriteriaFacade.changeSearchCriteriaByListType(
              { ...searchCriteria, materialView, viewMode },
              ListSearchCriteriaType.Shipment,
            );

            return true;
          }),
        );
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentListFacade);
  }
}
